module.exports = __webpack_public_path__ + "img/aeroland-client-logo-01-hover.292fb5ee.png";